import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  makeStyles,
  Typography
} from '@material-ui/core';
import React, { FC, useEffect, useState } from 'react';

const WaitSecond = 30;
const IdleSecond = 60 * 3;
const useStyles = makeStyles(theme => ({
  content: {
    padding: theme.spacing(1),
    display: 'flex'
  },
  wrapper: {
    flex: 1
  },
  menuTitle: {
    lineHeight: 1.2,
    margin: theme.spacing(2)
  },
  buttonMargin: {
    margin: theme.spacing(1) / 2
  }
}));

export enum TypeIdleTime {
  Kiosk = 'kiosk',
  Web = 'web'
}

const IdleTime: FC<{ type: TypeIdleTime }> = ({ type }) => {
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const [cancelTime, setCancelTime] = useState(WaitSecond);
  const handleClose = (isAgree: boolean) => {
    setOpen(false);
    setTimeout(() => setCancelTime(WaitSecond), 100);
    if (isAgree) {
      return;
    } else {
      window.location.reload();
    }
  };

  useEffect(() => {
    if (cancelTime === 0 && open === true) {
      return handleClose(false);
    }
    if (cancelTime !== 0 && open === true) {
      const cancelTimeInterval = setInterval(() => {
        const current = cancelTime - 1;
        setCancelTime(current);
      }, 1000);
      return () => {
        clearInterval(cancelTimeInterval);
      };
    }
  }, [open, cancelTime]);

  const handle = () => {
    if (!open) {
      setOpen(true);
    }
  };

  (() => {
    window.onmousemove = resetTimer;
    window.onmousedown = resetTimer;
    window.ontouchstart = resetTimer;
    window.ontouchmove = resetTimer;
    window.onclick = resetTimer;
    window.onkeydown = resetTimer;
    window.addEventListener('scroll', resetTimer, true);

    function resetTimer() {
      clearTimeout((window as any).idleTime);
      (window as any).idleTime = setTimeout(handle, IdleSecond * 1000); // time is in milliseconds
    }
  })();

  return type === TypeIdleTime.Web ? (
    <Dialog open={open}>
      <DialogTitle>Are you still there?</DialogTitle>
      <DialogActions>
        <Button onClick={() => handleClose(false)} color="secondary">
          Cancel({cancelTime}s)
        </Button>
        <Button onClick={() => handleClose(true)} color="primary">
          Give me a minute
        </Button>
      </DialogActions>
    </Dialog>
  ) : (
    <Dialog open={open} scroll="paper" fullWidth={true} maxWidth="md">
      <DialogContent dividers classes={{ root: classes.content }}>
        <Typography variant="h5" className={classes.menuTitle}>
          Are you still there?
        </Typography>
      </DialogContent>
      <DialogActions>
        <Grid container direction="row" justify="center">
          <Button
            onClick={() => handleClose(false)}
            className={classes.buttonMargin}
            variant="contained"
            color="primary"
            size="large"
          >
            Cancel({cancelTime}s)
          </Button>
          <Button
            onClick={() => handleClose(true)}
            className={classes.buttonMargin}
            variant="contained"
            color="primary"
            size="large"
          >
            Give me a minute
          </Button>
        </Grid>
      </DialogActions>
    </Dialog>
  );
};

export default IdleTime;
